import {
    useMutation,
} from '@tanstack/react-query'
import noop from 'lodash/noop'
import simpleApi from 'app/services/simpleApi'
import requests from 'app/requests/Attachment.requests'

import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

const useUploadFile = (onSuccess: (id: number) => void = noop) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessHandler,
        onError,
        onStartSaving,
    } = useHandleStatusRequest({
        id: 'Attachment',
        onSuccess,
    })

    const {
        mutateAsync: uploadFile,
    } = useMutation({
        mutationFn: (data: FormData) => {
            onStartSaving()
            return simpleApi({
                ...requests.create({
                    data,
                }),
                token,
            }).then((id) => {
                return id
            })
        },
        onSuccess: onSuccessHandler,
        onError,
    })

    return uploadFile
}

export default useUploadFile
